import { Block } from "@components/block";
import { Breadcrumbs } from "@components/breadcrumbs";
import { Config, DoubleText, Table } from "@components/table";
import { useWithdrawals } from "@features/withdrawals";
import { Withdrawal } from "@features/withdrawals/api";
import { formatDate, formatTime } from "@helpers/date";
import { useEffect, useState } from "react";
import styles from "./payouts.module.scss";
import { CustomSelect, SelectOption } from "@components/select";
import { useForm } from "react-hook-form";
import { useWallets } from "@features/wallets";
import { usePagination } from "@hooks/use-pagination";
import { EllipsisText } from "@components/ellipsis-text";
import {
  formatUsdt,
  getTronScanAddresUrl,
  getTronScanTxUrl,
} from "@helpers/format";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const withdrawalsConfig: Config<Withdrawal> = [
  {
    source: "id",
    label: "Id",
    renderComponent: (data) => <EllipsisText text={data} copy />,
  },
  {
    source: "address",
    label: "Адрес",
    renderComponent: (data) => (
      <EllipsisText
        text={data}
        copy
        link={getTronScanAddresUrl(data)}
        startLength={6}
        endLength={6}
      />
    ),
  },
  {
    source: "hash",
    label: "hash",
    renderComponent: (data) => (
      <EllipsisText
        text={data}
        copy
        link={getTronScanTxUrl(data)}
        startLength={6}
        endLength={6}
      />
    ),
  },
  {
    source: "status",
    label: "Статус",
  },
  {
    source: "sum",
    label: "Сумма",
    renderComponent: (data, cellData) => data + cellData.commission + " USDT",
  },
  {
    source: "commission",
    label: "Комиссия",
    renderComponent: (data) => formatUsdt(data),
  },
  {
    source: "sum",
    label: "К переводу",
    renderComponent: (data) => data + " USDT",
  },
  {
    source: "date",
    label: "Дата",
    renderComponent: (dateTime) => (
      <DoubleText
        text={formatTime(new Date(dateTime))}
        subText={formatDate(new Date(dateTime))}
      />
    ),
  },
];

type IFilter = {
  wallets: string;
};

export const PayoutsPage = () => {
  const { state: withdrawalsState, getWithdrawals } = useWithdrawals();
  const { state: walletState, getWallets } = useWallets();
  const [walletOptions, setWalletOptions] = useState<SelectOption[]>([]);
  const { control, watch } = useForm<IFilter>();
  const { page, limit, setPage, setLimit } = usePagination();
  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && lastMessage.type == WebsocketUpdateType.Withdrawal) {
      getWithdrawals({ page, limit });
    }
  }, [lastMessage, page, limit]);

  useEffect(() => {
    getWithdrawals({ wallets: watch("wallets") });
  }, [watch("wallets")]);

  useEffect(() => {
    getWithdrawals({ page, limit });
  }, [getWithdrawals, page, limit]);

  useEffect(() => {
    getWallets();
  }, [getWallets]);

  useEffect(() => {
    if (walletState.wallets) {
      const options = walletState.wallets
        .map((wallet) => ({
          value: wallet.address,
          text: wallet.address,
        }))
        .filter((option) => option.value.length > 0);

      setWalletOptions(options);
    }
  }, [walletState.wallets]);

  return (
    <div className={styles.container}>
      <Breadcrumbs items={["История выводов"]} />
      <Block>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          <h3>История выводов</h3>
          <CustomSelect
            name="wallets"
            control={control}
            options={walletOptions}
            placeholder="Адрес"
          />
        </div>
        <Table
          config={withdrawalsConfig}
          data={withdrawalsState.withdrawals}
          loading={withdrawalsState.loading}
          setPage={setPage}
          setLimit={setLimit}
          page={page}
          limit={limit}
          totalCount={withdrawalsState.count}
        />
      </Block>
    </div>
  );
};
